import { browserHistory } from 'react-router'

import { getFormats } from 'reduxpath/ducks/Format/List'
import {
  getServices,
  setServiceSelections,
} from 'reduxpath/ducks/Format/Add'
import { getFormatById } from 'reduxpath/ducks/Format/Edit'
import { removeFormat } from 'reduxpath/ducks/Format/Remove'

import Home from 'units/Format'
import List from 'units/Format/units/List'
import Add from 'units/Format/units/Add'
import Edit from 'units/Format/units/Edit'

const list = (store) => {
  store.dispatch(
    getFormats({
      sort: 'name ASC',
      limit: 10,
      skip: 0,
    }),
  )
}

const add = (store) => {
  store.dispatch(
    getServices((res) => {
      const serviceSelections = res.rows.map(service => ({
        label: service.name,
        value: service.id,
      }))
      store.dispatch(setServiceSelections(serviceSelections))
    }),
  )
}

const edit = (store, id) => {
  store.dispatch(
    getFormatById(id),
  )

  store.dispatch(
    getServices((res) => {
      const serviceSelections = res.rows.map(service => ({
        label: service.name,
        value: service.id,
      }))
      store.dispatch(setServiceSelections(serviceSelections))
    }),
  )
}

const remove = (store, id) => {
  store.dispatch(
    removeFormat(id, () => {
      browserHistory.push('/formats')
    }),
  )
}

export default {
  populate: {
    list,
    add,
    edit,
    remove,
  },
  components: {
    Home,
    List,
    Add,
    Edit,
  },
}
